<style lang="scss" scoped>
.header-container {
  position: relative;
  height: 70px;
  background: url('../../../assets/images/navbar1.png');
  .title {
    float: left;
    font-size: 18px;
    color: #fff;
    font-weight: 700;
    line-height: 70px;
    padding: 0;
    margin: 0;
  }
  img {
    height: 42px;
    margin-right: 60px;
    margin-top: 3px;
  }
  .hamburger {
    vertical-align: middle;
    width: 20px;
    height: 20px;
  }
  i {
    margin-right: 2px;
  }
  .hamburger.is-active {
    transform: rotate(180deg);
  }
}
.mobile {
  .header-container {
    .user {
      margin-right: 30px;
    }
    img {
      margin-right: 20px;
    }
  }
}
.logo {
  float: left;
  padding: 5px 0 0 25px;
}
.logo img {
  height: 55px;
  margin-right: 15px !important;
}
.el-dropdown-link {
  cursor: pointer;
  color: #ffffff;
  display: inline-block;
  padding: 10px 20px;
}
.el-dropdown-link:hover {
  border-radius: 20px;
  background: #1683e6;
}
.el-icon-arrow-down {
  font-size: 14px;
}
.el-dropdown-link-active {
  cursor: pointer;
  color: #ffffff;
  display: inline-block;
  padding: 10px 20px;
  border-radius: 20px;
  background: #1683e6;
}
</style>
<template>
  <div class="header-container">
    <el-row>
      <el-col :span="6">
        <div class="logo">
          <img src="@/assets/images/u85.svg" />
        </div>
        <router-link to="Homenew">
          <h1 class="title">智慧安防综合管理平台</h1>
        </router-link>
      </el-col>
      <el-col :span="12" style="padding-top: 17px;font-size: 16px">
        <span
          :class="item.active ? 'el-dropdown-link-active' : 'el-dropdown-link'"
          v-for="(item, index) in menus"
          :key="index"
          @click="menuClick(item)"
        >
          <i :class="item.icon"></i>{{ item.chName }}
        </span>
      </el-col>
      <el-col :span="6" style="padding-top: 17px">
        <User />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Hambuger from "./Hambuger";
import Breadcrumb from "./Breadcrumb";
import User from "./User";
export default {
  data() {
    return {
      menus: [
      ],
    };
  },
  watch: {
    $route(to, from) {
      let tempPath = to.path.split("/")[1];
      let tempObj = this.menus.filter((item) => {
        if (item.url.indexOf(tempPath) > -1) return item;
      })[0];
      let tempIndex = this.menus.indexOf(tempObj);
      this.menus = this.menus.map((item) => {
        item.active = false;
        return item;
      });
      this.menus[tempIndex].active = true;
    },
  },
  methods: {
    menuClick(item) {
      this.$router.push(item.url);
    },
    handleCommand(command) {
      console.log(command);
    },
    getMenus(){
      this.menus = JSON.parse(localStorage.getItem('USER_MENU_LIST'))

    }
  },
  components: { Hambuger, Breadcrumb, User },
  mounted() {
    this.getMenus();
    let tempPath = this.$route.path.split("/")[1];
    let tempObj = this.menus.filter((item) => {
      if (item.url.indexOf(tempPath) > -1) return item;
    })[0];
    let tempIndex = this.menus.indexOf(tempObj);
    this.menus = this.menus.map((item) => {
      item.active = false;
      return item;
    });
    this.menus[tempIndex].active = true;
  },
};
</script>


